import React, { useEffect, useState } from 'react';

import { Link, withRouter } from 'react-router-dom';

import Api from '../../../util/api';

import t, { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import { formatCurrencyNumber } from '../../../util/functions';
import StarIcon from 'mdi-react/StarIcon';

const s = partial('shared');
const d = partial('Deals');

const TopCompaniesList = ({ setLoading, startEndObject }) => {
  const config = useConfig();

  const [topCompanies, setTopCompanies] = useState([]);
  const listTopCompanies = () => {
    if (topCompanies.length === 0) {
      return (
        <div className="pt-2">
          <div className="flex justify-center my-2">
            <div
              style={{
                background: '#F4F4F6',
                borderRadius: 12,
                height: 35,
                width: 35,
              }}
            >
              <div
                style={{
                  margin: '6px 8px',
                  height: 18,
                }}
              >
                <StarIcon style={{ width: 18 }} />
              </div>
            </div>
          </div>
          <p className="m-2 block center-text">No data</p>
        </div>
      );
    }
    return topCompanies.map((deal, i) => (
      <Link
        to={`/companies/edit/${deal.companyId}?tab=1`}
        style={{ background: i % 2 ? '#fff' : '#F9FAFB' }}
        key={`topCompanies-${deal.companyId}`}
        className="flex space-between p-3"
      >
        <div className="flex flex-start">
          <div className="mt-2 mr-2">
            <span style={{ color: '#98A0AE' }}>{i + 1}</span>
          </div>
          {deal?.companyImage ? (
            <img
              className="company__profile__avatar mr-2"
              src={deal?.companyImage}
              alt="logo"
            />
          ) : (
            <div
              className="mr-2"
              style={{
                height: 30,
                width: 30,
                borderRadius: 20,
                background: '#0469dc',
                display: 'inline-block',
              }}
            ></div>
          )}

          <div>
            <span
              style={{
                display: 'block',
                fontWeight: 600,
                fontSize: 14,
                color: '#000',
              }}
            >
              {deal?.companyName}
            </span>
            <span style={{ display: 'block', color: '#98A0AE' }}>
              {deal.dealsCount} {d('activities')}
            </span>
          </div>
        </div>
        <div>
          <span
            style={{
              display: 'block',
              fontWeight: 700,
              fontSize: 14,
              color: '#000',
            }}
          >
            {formatCurrencyNumber(deal.value)} {config.currencyCaps}
          </span>
        </div>
      </Link>
    ));
  };

  const fetchTopCompanies = async () => {
    setLoading(true);
    try {
      const resDeals = await Api.companies.getCompanyDeals(
        { page: 1, take: 5 },
        {
          orderBy: 'value',
          direction: 'DESC',
          startDate: startEndObject.start,
          endDate: startEndObject.end,
        }
      );
      setTopCompanies(resDeals.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTopCompanies();
  }, [startEndObject]);

  return (
    <div
      style={{
        paddingBottom: 5,
        background: '#fff',
        borderRadius: 6,
        boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
      }}
    >
      <div className="p-3 border-bottom">
        <h4>{d('topCompanies')}</h4>
      </div>
      {listTopCompanies()}
    </div>
  );
};

export default withRouter(TopCompaniesList);
